// Generated by ReScript, PLEASE EDIT WITH CARE


var web_tracking_id = "web_tracking_id";

var auth_token = "auth-token";

var mobile = "mobile";

var deliveryCk = "delivery_ck";

var visitorId = "visitor_id";

export {
  web_tracking_id ,
  auth_token ,
  mobile ,
  deliveryCk ,
  visitorId ,
}
/* No side effect */
